import React from 'react';
import { Bot } from 'lucide-react';

interface AIFeaturesToggleProps {
  aiFeaturesEnabled: boolean;
  setAiFeaturesEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
}

export const AIFeaturesToggle: React.FC<AIFeaturesToggleProps> = ({
  aiFeaturesEnabled,
  setAiFeaturesEnabled,
  isLoading,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        <Bot className="w-4 h-4 inline mr-2" />
        AI Features
      </label>
      <div className="flex items-center space-x-3">
        <button
          type="button"
          onClick={() => setAiFeaturesEnabled(!aiFeaturesEnabled)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800
            ${aiFeaturesEnabled ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-600'}
            ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
          disabled={isLoading}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition-transform
              ${aiFeaturesEnabled ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
        <span className="text-sm text-gray-600 dark:text-gray-400">
          {aiFeaturesEnabled ? 'AI features enabled' : 'AI features disabled'}
        </span>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        Enable or disable AI-powered features throughout the application, including AI Assistant, task suggestions, and quick actions.
      </p>
    </div>
  );
};